import HttpStatus from 'http-status-codes';

export const SuccessHttpStatus: Array<number> = [
    HttpStatus.OK,
    HttpStatus.NO_CONTENT
];

export const UnauthorizedHttpStatus: Array<number> = [
    HttpStatus.UNAUTHORIZED
];
